<google-map height="100%" width="100%"
            [center]=center
            [zoom]=zoom
            [options]=options
            (zoomChanged)="onZoomChanged()"
            (mapClick)="onMapClicked($event)"
            (centerChanged)="onCenterChanged()">

  <map-marker *ngFor="let marker of markers"
              #somemarker="mapMarker"
              [position]="marker.position"
              [label]="marker.label"
              [options]="marker.options"
              [icon]="marker.icon"
              (mapClick)="onMarkerClicked(marker)"
              (mapMouseover)="onMarkerMouseOver(somemarker, marker.info)">
  </map-marker>


  <map-info-window [innerHTML]="infoContent"></map-info-window>

</google-map>
